import { render } from "./AllServices.vue?vue&type=template&id=fb48a09c"
import script from "./AllServices.vue?vue&type=script&lang=js"
export * from "./AllServices.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/G23/web-portal/bia-webportal-prod/bia-cms-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__